import token from 'styled-token';

/** @mixin disabledOpacityMixin */
/**
 * Adds disabled opacity styling to a component.
 * If there is also cursor change on the disabled styling,
 * considering using `disabledMixin` for simplicity.
 *
 * @example
 * import { disabledOpacityMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${disabledOpacityMixin}
 * `;
 *
 * <Component>My component with regular opacity styling</Component>
 * <Component disabled>My component with disabled opacity styling</Component>
 *
 * @method
 * @param props {object}
 * @param {boolean} [props.disabled=false] - Renders the opacity as disabled.
 * @return {CSSObject}
 */
export var disabledOpacityMixin = function disabledOpacityMixin(props) {
  var disabled = props.disabled;
  if (!disabled) {
    return '';
  }
  return token('opacities.disabled', function (opacity) {
    return "opacity: " + opacity + ";";
  })(props);
};